import { render, staticRenderFns } from "./ServiceRecommendation.vue?vue&type=template&id=1b115cb9&scoped=true&"
import script from "./ServiceRecommendation.vue?vue&type=script&lang=js&"
export * from "./ServiceRecommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b115cb9",
  null
  
)

export default component.exports